document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initResenas();
  initGaleriaProducto();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  els.forEach(function (el) { observer.observe(el); });
}

function initResenas() {
  var track = document.querySelector('.mt-resenas-track');
  if (!track) return;

  var prev = document.querySelector('[data-mt-resenas-prev]');
  var next = document.querySelector('[data-mt-resenas-next]');
  if (!prev || !next) return;

  function scrollByCard(dir) {
    var card = track.querySelector('.mt-resena-card');
    var gap = 20;
    var amount = card ? card.offsetWidth + gap : 320;
    track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  prev.addEventListener('click', function () { scrollByCard(-1); });
  next.addEventListener('click', function () { scrollByCard(1); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('.mt-producto-galeria');
  if (!galerias.length) return;

  galerias.forEach(function (galeria) {
    var imagenPrincipal = galeria.querySelector('.mt-galeria-principal img');
    var botones = galeria.querySelectorAll('.mt-mini-btn');
    if (!imagenPrincipal || !botones.length) return;

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var nuevaImagen = boton.getAttribute('data-mt-mini-imagen');
        if (!nuevaImagen) return;
        imagenPrincipal.src = nuevaImagen;
        botones.forEach(function (b) { b.classList.remove('mt-mini-activa'); });
        boton.classList.add('mt-mini-activa');
      });
    });
  });
}
